import React, { useEffect, useState } from 'react';
interface RangeSliderProps {
  label: string;
  min: number;
  max: number;
  step?: number;
  defaultValue?: number;
  formatValue?: (value: number) => string;
  onChange?: (value: number) => void;
  accentColor?: 'cyan' | 'purple';
}
export function RangeSlider({
  label,
  min,
  max,
  step = 1,
  defaultValue,
  formatValue = v => v.toString(),
  onChange,
  accentColor = 'cyan'
}: RangeSliderProps) {
  const [value, setValue] = useState(defaultValue || min);
  useEffect(() => {
    if (defaultValue) setValue(defaultValue);
  }, [defaultValue]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    onChange?.(newValue);
  };
  const percentage = (value - min) / (max - min) * 100;
  const colorClass = accentColor === 'cyan' ? 'bg-cyan-500' : 'bg-purple-500';
  return <div className="mb-8" data-id="element-614">
      <div className="flex justify-between items-end mb-4" data-id="element-615">
        <label className="text-sm font-medium text-slate-300" data-id="element-616">{label}</label>
        <span className={`text-lg font-bold ${accentColor === 'cyan' ? 'text-cyan-400' : 'text-purple-400'}`} data-id="element-617">
          {formatValue(value)}
        </span>
      </div>

      <div className="relative w-full h-2 bg-slate-800 rounded-full" data-id="element-618">
        <div className={`absolute h-full rounded-full ${colorClass}`} style={{
        width: `${percentage}%`
      }} data-id="element-619" />
        <input type="range" min={min} max={max} step={step} value={value} onChange={handleChange} className="absolute w-full h-full opacity-0 cursor-pointer" data-id="element-620" />
        <div className={`absolute w-5 h-5 bg-white rounded-full shadow-lg top-1/2 -translate-y-1/2 -ml-2.5 pointer-events-none transition-transform active:scale-110`} style={{
        left: `${percentage}%`
      }} data-id="element-621" />
      </div>
      <div className="flex justify-between mt-2 text-xs text-slate-500" data-id="element-622">
        <span data-id="element-623">{formatValue(min)}</span>
        <span data-id="element-624">{formatValue(max)}+</span>
      </div>
    </div>;
}